import { PROJECT_TYPES } from 'constants/commonProjects';

export const DIALOG_VARIANT = {
  PASS_UPDATE: 'pass_update',
  CREATE_MASTER_DASHBOARD: 'create_master_dashboard',
  RENAME: 'rename',
  CONFIRMATION: 'confirmation',
  CONFIRMATION_WITH_INPUT: 'confirmation_with_input',
  DUPLICATE_PROJECT: 'duplicate_project',
  RESET_PASSWORD: 'reset_password',
  ADD_USER: 'add_user',
  ORGANISATION_USER_DETAILS: 'organisation_user_details',
  LEADERS_PERMISSIONS: 'leaders_permissions',
  EXPORT_ENTRIES: 'export_entries',
  SAVE_CREATED_MASTER_DASHBOARD: 'save_created_master_dashboard',
  START_FEEDBACK_ROUND: 'start_feedback_round',
  EDIT_FRAMEWORK_RECIPIENT_DEADLINE: 'edit_framework_recipient_deadline',
  INVALID_INVITES: 'invalid_invites',
  KEY_EVENTS: 'key_events',
  NOMINEE_MODAL: 'nominee_modal',
};

export const RENAME_DIALOG_VARIANT = {
  ...PROJECT_TYPES,
  ORGANISATION: 'organisation',
  MASTER_DASHBOARD: 'master_dashboard',
};

export const CONFIRMATION_DIALOG_VARIANTS = {
  ARCHIVE_ORGANISATION: 'archive_organisation',
  UNARCHIVE_ORGANISATION: 'unarchive_organisation',
  DELETE_ORGANISATION: 'delete_organisation',
  DELETE_PROJECT: 'delete_project',
  DELETE_ARCHIVED_PROJECT: 'delete_archived_project',
  ARCHIVE_PROJECT: 'archive_project',
  UNARCHIVE_PROJECT: 'unarchive_project',
  ADD_PROJECT_RECIPIENTS: 'add_project_recipients',
  REMOVE_PROJECT_RECIPIENTS: 'remove_project_recipients',
  DELETE_USERS: 'delete_users',
  DELETE_INVITATION: 'delete_invitation',
  ENABLE_ORGANISATION_MFA: 'enable_organisation_mfa',
  DISABLE_ORGANISATION_MFA: 'disable_organisation_mfa',
  ENABLE_ORGANISATION_SSO: 'enable_organisation_sso',
  DISABLE_ORGANISATION_SSO: 'disable_organisation_sso',
  ADD_FRAMEWORK_RECIPIENTS: 'add_framework_recipients',
  LAUNCH_CULTURAL_PROJECT: 'launch_cultural_project',
  UPDATE_CULTURAL_PROJECT: 'update_cultural_project',
  UPDATE_CULTURAL_PROJECT_TYPE: 'update_cultural_project_type',
  UPDATE_ACTION_PLAN_SETTING: 'update_action_plan_setting',
  UPDATE_PROJECT_RECIPIENTS_ROLE: 'update_project_recipients_role',
  DELETE_NOMINEE: 'delete_nominee',
  SAVE_FF_DRAFT: 'save_ff_draft',
  SUBMIT_FEEDBACK: 'submit_feedback',
  LAUNCH_FEEDBACK: 'launch_feedback',
  CONFIRM_FEEDBACK_NOMINEES: 'confirm_feedback_nominees',
  CANCEL_FEEDBACK_ROUND: 'cancel_feedback_round',
  RESTORE_DELETED_ITEM: 'restore_deleted_item',
  SAVE_MASTER_DASHBOARD: 'save_master_dashboard',
  DELETE_MASTER_DASHBOARD: 'delete_master_dashboard',
  UPDATE_MASTER_DASHBOARD: 'update_master_dashboard',
  CLOSE_ACTIVE_CP_SEGMENTS_EDIT: 'close_active_cp_segments_edit',
  CONFIRM_ACTIVE_CP_SEGMENTS_EDIT: 'confirm_active_cp_segments_edit',
  DELETE_ACTION: 'delete_action',
  DELETE_JOURNAL: 'delete_journal',
  DELETE_THEME_PRIORITISATION_ITEM: 'delete_theme_prioritisation_item',
  DELETE_JOURNAL_ENTRY: 'delete_journal_entry',
};

export const CONFIRMATION_DIALOG_WITH_INPUT_VARIANTS = {
  DELETE_ARCHIVED_PROJECT: 'delete_archived_project',
  DELETE_USERS: 'delete_users',
  DELETE_ORGANISATION: 'delete_organisation',
  RESTORE_DELETED_ITEM: 'restore_deleted_item',
};
